<div class="container-mni-cart">
  <a [routerLink]="['/carrinho']" routerLinkActive="router-link-active" class="d-flex">
    <span class="material-symbols-outlined"> shopping_cart </span>

    <div *ngIf="cart$ | async as cart" class="qty">
      {{ cart.data?.totalItems || 0 }}
    </div>
  </a>

  @if (cart$ | async; as cart) {
    <div class="menu">
      <div class="menu-container">
        <div>
          <strong>{{ cart.data?.totalItems || 0 }} Produtos | {{ cart.data?.totalPrice || 0 | currency: 'BRL' }}</strong>
        </div>
      </div>
    </div>
  }
</div>
